import { render, staticRenderFns } from "./OutboxLetterId.vue?vue&type=template&id=45157934"
import script from "./OutboxLetterId.vue?vue&type=script&lang=js"
export * from "./OutboxLetterId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports